export const ACCEPTED_FILE_TYPES = [
  'audio/webm',
  'video/webm',
  'audio/mp4',
  'audio/wav',
];

export interface ExtraData {
  [k: string]: any;
}
